// Utilidades compartidas por las pantallas de grupos y permisos

export const ACCESO = 'ACCESO';

export const mensajeError = (e, porDefecto) => e?.response?.data?.message || porDefecto;

// Arma el arbol de menus a partir de la lista plana (id, idMenuPadre), respetando el orden recibido.
// Las opciones cuyo padre no existe o esta inactivo se descartan: tampoco aparecen en el menu real.
export const armarArbol = (menus) => {
    const porId = new Map(menus.map(m => [m.id, { ...m, hijos: [] }]));
    const raices = [];
    porId.forEach(n => {
        if (!n.idMenuPadre || n.idMenuPadre === n.id) { raices.push(n); return; }
        const padre = porId.get(n.idMenuPadre);
        if (padre) padre.hijos.push(n);
    });
    return raices;
};

// Ids de las opciones finales (sin hijos) que cuelgan de un nodo; el acceso se guarda sobre ellas
export const hojasDe = (nodo) => nodo.hijos.length === 0 ? [nodo.id] : nodo.hijos.flatMap(hojasDe);

export const coincide = (nodo, filtro) =>
    !filtro || nodo.descripcion?.toLowerCase().includes(filtro) || nodo.hijos.some(h => coincide(h, filtro));
